<template>
  <section class="services">
    <page-link :href="whensomeonediesPage.url" v-if="whensomeonediesPage">
      <span>{{whensomeonediesPage.name}}</span>
      <img :alt="whensomeonediesPage.name" :src="whensomeonediesPage.image" />
    </page-link>
    <page-link :href="funeralPage.url" v-if="funeralPage">
      <span>{{funeralPage.name}}</span>
      <img :alt="funeralPage.name" :src="funeralPage.image" />
    </page-link>
    <page-link :href="prepaidPage.url" v-if="prepaidPage">
      <span>{{prepaidPage.name}}</span>
      <img :alt="prepaidPage.name" :src="prepaidPage.image" />
    </page-link>
    <page-link :href="newsPage.url" v-if="newsPage">
      <span>{{newsPage.name}}</span>
      <img :alt="newsPage.name" :src="newsPage.image" />
    </page-link>
  </section>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "PageServices",
  computed: {
    ...mapState(["whensomeonediesPage", "funeralPage", "prepaidPage", "newsPage"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.services {
  margin-bottom: 3rem;
  clear: both;
  display: table;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.services a {
  display: table-cell;
  float: left;
  line-height: 0;
  overflow: hidden;
  font-family: "Merriweather", sans-serif;
}

.services a img {
  transition: all 0.2s;
  position: relative;
  z-index: 1;
}

.services a span {
  display: block;
  line-height: 1.6;
  padding: 2rem 3rem;
  color: white;
  text-transform: uppercase;
  font-size: 1.7rem;
  position: relative;
  z-index: 2;
  background: #bb9765;
}

.services a:nth-child(2) span,
.services a:nth-child(4) span,
.services a:nth-child(5) span,
.services a:nth-child(7) span {
  background: #9e7f54;
}

.services a:hover img {
  transform: scale(1.05);
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .services a {
    width: 23%;
    float: left;
  }
}

@media screen and (max-width: 750px) {
  .services {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 450px) {
  .services a span {
    min-height: 60px;
    padding: 1rem;
  }
}
</style>
